module.exports = __webpack_public_path__ + "static/media/hammer.0995f6b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/StatsBox/img/hammer.svg
// module id = 173
// module chunks = 0